<template>
  <div class="training-detail-about-component">
    <div class="training-content-block">
      <div class="training-block-title">阅读计划简介</div>
      <rich-text class="training-about"
                 :content="about"
      />
    </div>
  </div>
</template>

<script>
  import RichText from '@/components/RichText';

  export default {
    name: 'TrainingDetailAbout',
    components: {
      RichText,
    },
    props: {
      about: {
        type: String,
        required: true,
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .training-detail-about-component {
    background-color: @color-white;
  }

  .training-block-title {
    font-size: @font-size-medium;
    font-weight: @font-weight-primary;
    text-align: center;
    height: 88px;
    line-height: 88px;
    box-sizing: border-box;
    border-bottom: @border-base;
  }

  .training-about {
    min-height: @product-tab-min-height;
    line-height: 1.8;
    height: 100%;
    word-break: break-word;
  }
</style>
